import { PreviewPanelAris } from './ConfluencePreviewPanelTypes';

export const isPreviewPanelAvailable = ({ ari }: { ari: string }) => {
	return Object.values(PreviewPanelAris).some((regex) => regex.test(ari));
};
